<template>
  <div class="header-banner">
    <div class="header-search-box">
      <div class="header-search-input-box">
        <input type="text" v-model="keyword" placeholder="请输入关键字查询" @keyup.enter="goSearch" />
      </div>
      <div class="header-search-img-box">
        <img src="./../assets/ico-sousuo@2x.png" @click="goSearch" />
      </div>
    </div>
    <div class="header-search-heat">
      <div class="header-search-heat-label">
        <span>热搜事项：</span>
      </div>
      <div class="header-search-heat-value">
        <p
          :style="{transform: 'translateY(-'+hotScroll+'px)'}"
          v-for="(heat,heatIndex) in hotList"
          :key="heatIndex"
          @click="goHeat(heat.Name)"
          @mouseover="clearInterval"
          @mouseout="initInterVal"
        >{{heat.Name}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hotList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      keyword: "",
      hotScroll: 0,
      heatList: [],
      time: {}
    };
  },
  methods: {
    goSearch() {
      this.$emit("gosearch", this.keyword);
    },
    goHeat(heat) {
      this.keyword = heat;
      this.$emit("gosearch", this.keyword);
    },
    initInterVal() {
      this.time = setInterval(() => {
        this.hotScroll++;
        if (this.hotScroll == 30 * this.hotList.length) {
          this.hotScroll = 0;
        }
      }, 200);
    },
    clearInterval() {
      clearInterval(this.time);
    }
  },
  watch: {
    hotList(newValue, oldValue) {
      this.heatList = newValue;
      this.heatList = this.heatList.concat(newValue);
    }
  },
  mounted() {
    this.initInterVal();
  }
};
</script>

<style lang="scss" scoped>
//banner
.header-banner {
  width: 100%;
  height: 486px;
  background-image: url("./../assets/banner.png");
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  padding-top: 170px;

  .header-search-box {
    // position: relative;
    left: 0;
    right: 0;
    width: 850px;
    height: 60px;
    margin: auto;
    background-color: #ffffff;
    border: 1px solid #d3d3d3;
    border-radius: 2px;
    box-sizing: content-box;

    .header-search-input-box {
      width: 770px;
      height: 60px;
      float: left;
      padding: 10px 0;

      input {
        width: 100%;
        border-top: 0px;
        border-left: 0px;
        border-bottom: 0px;
        border-right: 1px solid #d3d3d3;
        height: 40px;
        outline: none;
        padding: 0 20px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;

        &::placeholder {
          color: #d3d3d3;
        }
      }
    }

    .header-search-img-box {
      width: 80px;
      height: 60px;
      float: right;
      padding: 19px 29px;

      img {
        cursor: pointer;
        width: 22px;
        height: 22px;
      }
    }
  }
  .header-search-heat {
    width: 850px;
    height: 50px;
    padding: 10px 50px;
    position: relative;
    left: 0;
    right: 0;
    margin: auto;
    display: flex;
    .header-search-heat-label {
      width: 100px;
      min-width: 100px;
      height: 30px;
      span {
        line-height: 30px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        cursor: pointer;
      }
    }
    .header-search-heat-value {
      width: 100%;
      height: 30px;
      overflow: hidden;
      p {
        width: 100%;
        height: 30px;
        text-align: left;
        line-height: 30px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-break: keep-all;
      }
    }
    // ul {
    //   width: 100%;
    //   height: 100%;
    //   li {
    //     float: left;
    //     list-style-type: none;
    //     margin-right: 10px;
    //     &:first-of-type {
    //       span {
    //         cursor: inherit;
    //       }
    //     }
    //     span {
    //       line-height: 30px;
    //       font-size: 14px;
    //       font-family: Microsoft YaHei;
    //       font-weight: 400;
    //       color: #666666;
    //       cursor: pointer;
    //     }
    //   }
    // }
  }
}
</style>